import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export const getItemAccessoryId = (item: CartItemFragment) =>
  `cartAccesoriesContainer-${item.id.toString()}`
